const sizes = {
  s: 12,
  m: 24,
  l: 48,
}

export interface EmptyCircleIconProps extends React.HTMLAttributes<HTMLOrSVGElement> {
  size: keyof typeof sizes
}

export function EmptyCircleIcon({ size, ...otherProps }: EmptyCircleIconProps) {
  return (
    <svg
      {...otherProps}
      aria-hidden="false"
      focusable="false"
      viewBox="0 0 24 24"
      role="img"
      height={sizes[size]}
      fill="none"
      id="CheckCircle-id"
    >
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z"
        clipRule="evenodd"
      ></path>
      <title>Circle-icon</title>
    </svg>
  )
}
